import { RevealText, FadeIn } from "../motion/Reveal";
import { SectionLabel } from "../motion/SectionLabel";
import { ABOUT_OORU, GEN } from "../../data/content";
import { AboutImageCarousel } from "./AboutImageCarousel";

export const AboutOoru = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative min-h-screen flex flex-col justify-center py-28 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-[1400px] mx-auto">
        <SectionLabel>{ABOUT_OORU.label}</SectionLabel>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <RevealText
              as="h2"
              lines={[
                "OORU is the original",
                "entertainment IP division",
                "founded by the team behind",
                "Cinimage Studios.",
              ]}
              className="font-display font-bold text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.04] tracking-tight"
            />
            {ABOUT_OORU.paragraphs.map((p, i) => (
              <FadeIn key={i} delay={0.1 + i * 0.1}>
                <p className="mt-8 font-body text-lg md:text-xl text-neutral-400 leading-relaxed font-light max-w-3xl">
                  {p}
                </p>
              </FadeIn>
            ))}

            <FadeIn delay={0.25}>
              <div className="mt-12 border-l-2 border-[#ff4500] pl-6 md:pl-10">
                <span className="font-body text-xs uppercase tracking-[0.28em] text-neutral-500">
                  {ABOUT_OORU.ambitionLabel}
                </span>
                <p className="mt-3 font-display font-medium text-2xl md:text-4xl text-white tracking-tight max-w-3xl">
                  {ABOUT_OORU.ambition}
                </p>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.15} className="lg:col-span-5 group relative overflow-hidden rounded-2xl border border-white/10 aspect-[4/5]">
            <AboutImageCarousel images={GEN.aboutCarousel} />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#050505]/70 via-transparent to-transparent" />
          </FadeIn>
        </div>
      </div>
    </section>
  );
};
